var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#32C36C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77943 8.03202H5.71177C5.31867 8.03202 5 8.355 5 8.75347V11.2786C5 11.677 5.31867 12 5.71177 12H6.77943M6.77943 8.03202L7.91876 5.43368C8.0765 5.07392 8.49997 4.88804 8.84339 5.07196C9.37784 5.35819 9.27063 5.62648 9.27063 7.31056H11.2881C11.7243 7.31056 12.0579 7.70468 11.9916 8.14171L11.4988 11.3882C11.4454 11.7402 11.1466 12 10.7953 12H6.77943V8.03202ZM6.77943 8.03202V12V8.03202Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsupicon);
export default __webpack_public_path__ + "static/media/thumbsupicon.5b4234614fc6dae09b25451a94d670f6.svg";
export { ForwardRef as ReactComponent };